import styled, { keyframes } from "styled-components";
import { bounceInDown, bounceInLeft } from "react-animations";
const bounceInDownAnimation = keyframes`${bounceInDown}`;
const bounceInLeftAnimation = keyframes`${bounceInLeft}`;
export const Page = styled.div`
  width: 100%;
  height: 100vh;
  padding: 0px 30px;
  display: flex;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;
export const Welcome = styled.div`
  display: flex;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: 1s ${bounceInDownAnimation};
  h1 {
    font-size: 3.5vw;
    margin: 0px;
    color: ${({ theme }) => theme.colors.secondary100};
  }
  h2 {
    font-size: 1.5vw;
    color: ${({ theme }) => theme.colors.secondary70};
    margin-bottom: 60px;
    span {
      font-weight: 600;
      color: ${({ theme }) => theme.colors.secondary100};
    }
  }
`;
export const Loaded = styled.div`
  display: flex;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: 1s ${bounceInDownAnimation};
  h1 {
    font-size: 3.5vw;
    margin: 0px;
    color: ${({ theme }) => theme.colors.secondary100};
  }
  h2 {
    font-size: 1.5vw;
    color: ${({ theme }) => theme.colors.secondary70};
    margin-bottom: 60px;
  }
`;
export const Register = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  h1 {
    font-size: 2.5vw;
    margin: 0px;
    color: ${({ theme }) => theme.colors.secondary100};
    animation: 1s ${bounceInLeftAnimation};
  }
  form {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px;
    background-color: ${({ theme }) => theme.colors.secondary10};
    border-radius: 8px;
    padding: 30px;
    .form-group {
      display: flex;
      flex-direction: column;
      span {
        font-size: 16px;
        margin-bottom: 5px;
        font-weight: 500;
      }
    }
  }
`;
export const Plans = styled.div`
  display: flex;
  flex-direction: column;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 100%;
  h1 {
    font-size: 2.5vw;
    margin: 0px;
    color: ${({ theme }) => theme.colors.secondary100};
  }
  h2 {
    font-size: 1.5vw;
    color: ${({ theme }) => theme.colors.secondary70};
    margin-bottom: 60px;
  }
  .selection-plans {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    gap: 52px;
  }
`;
export const Success = styled.div`
  display: flex;
  flex-direction: column;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 100%;
  animation: 1s ${bounceInDownAnimation};
  img {
    width: 180px;
  }
  h1 {
    font-size: 2.5vw;
    margin: 0px;
    color: ${({ theme }) => theme.colors.secondary100};
  }
  h2 {
    font-size: 1.5vw;
    color: ${({ theme }) => theme.colors.secondary70};
    width: 80%;
    text-align: center;
  }
  .selection-plans {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    gap: 52px;
  }
`;
